import { Directive, Input } from '@angular/core';

import { A11yBooleanInput } from '../interfaces/a11y.interfaces';
import { toBoolean } from '../utils/a11y.util';

@Directive({
  selector: '[khA11yDisclosure]'
})
export class A11yDisclosureDirective {
  private panelId: string | null = null;

  @Input('khA11yDisclosure') public open: A11yBooleanInput = false;

  public get isOpen(): boolean {
    return toBoolean(this.open);
  }

  public registerPanel(id: string): void {
    this.panelId ??= id;
  }

  public unregisterPanel(id: string): void {
    if (this.panelId === id) {
      this.panelId = null;
    }
  }

  public getPanelId(): string | null {
    return this.panelId;
  }
}
